import { tagName } from "@ember-decorators/component"
import Component from "@ember/component"
import { action, computed, get } from "@ember/object"
import { inject as service } from "@ember/service"
import type { CardStack } from "@shared/models/card-stack"
import type { Planbook } from "@shared/models/planbook"
import type RoutineEditor from "cc-frontend/services/routine-editor"
import { sortBy } from "lodash-es"
import styles from "./body.module.css"

@tagName("")
export default class ChangeClassOrder extends Component {
  readonly styles = styles
  // Component Args
  routine!: CardStack
  planbook!: Planbook
  dateString!: string

  // Services
  @service routineEditor!: RoutineEditor

  // Computed Properties
  @computed("routine.attributes.cards", "routine.attributes._revision")
  get sortedCards() {
    let cards = get(get(get(this, "routine"), "attributes"), "cards")
    return sortBy(cards, (card) => {
      return card.attributes.position
    })
  }

  // Actions
  @action
  reorderCards(_oldList, newList, draggedItem) {
    this.routineEditor.reorderCards(
      this.planbook,
      this.routine,
      this.dateString,
      newList,
      draggedItem
    )
  }
}
